// miles
export const ONE_MILE_IN_M = 1609.34;
export const ONE_MILE_IN_KM = ONE_MILE_IN_M / 1000;

// feet
export const ONE_FT_IN_M = 0.3048;
export const ONE_FT_IN_KM = ONE_FT_IN_M / 1000;

// weights
export const ONE_LB_IN_KG = 0.453592;
export const ONE_LB_IN_G = ONE_LB_IN_KG * 1000;
